import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { getTokenNetworkMetadataForToken } from "../../api/token"

const BasicInfo = ({ symbol }) => {

    const [networkMetadata, setNetworkMetadata] = useState([]);

    const fetchData = () => {
        getTokenNetworkMetadataForToken(symbol).then((data) => {
            setNetworkMetadata(data);
        });
    }

    useEffect(() => {
        fetchData();
    }, [symbol]);


    const timeStampToFriendlyDate = (timeStamp) => {
        return dayjs.unix(timeStamp).format('YYYY-MM-DD HH:mm');
    }


    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead  sx={{ backgroundColor: 'var(--primary-color)' }}>
                    <TableRow>
                        <TableCell
                        sx={{ 
                        color: 'var(--background-color)', 
                        borderColor: 'var(--primary-color)' ,
                        fontWeight: 'bold',
                        fontSize: 18
                        }}
                        >Network</TableCell>
                        <TableCell
                        sx={{ 
                        color: 'var(--background-color)', 
                        borderColor: 'var(--primary-color)' ,
                        fontWeight: 'bold',
                        fontSize: 18
                        }}
                        >Earliest Datapoint</TableCell>
                        <TableCell
                        sx={{ 
                        color: 'var(--background-color)', 
                        borderColor: 'var(--primary-color)' ,
                        fontWeight: 'bold',
                        fontSize: 18
                        }}
                        >Latest Datapoint</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody sx={{ backgroundColor: 'var(--background-color)'}}>
                    {networkMetadata.map((network) => (
                        <TableRow key={`${network.network}`}>
                            <TableCell
                            sx={{ 
                                color: 'var(--text-color)', 
                                borderColor: 'var(--primary-color)',
                                fontWeight: 'bold',
                            }}
                            >{network.network}</TableCell>
                            <TableCell
                            sx={{ 
                                color: 'var(--text-color)', 
                                borderColor: 'var(--primary-color)',
                                fontWeight: 'bold',
                            }}
                            >{timeStampToFriendlyDate(network.earliest_time_stamp)}</TableCell>
                            <TableCell
                            sx={{ 
                                color: 'var(--text-color)', 
                                borderColor: 'var(--primary-color)',
                                fontWeight: 'bold',
                            }}
                            >{timeStampToFriendlyDate(network.latest_time_stamp)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )

};

export default BasicInfo;